import { CoveragePremiumInterface } from '@app/core/interfaces';
import { createSelector } from '@ngrx/store';
import { getMyZoneState, MyZoneState } from '../my-zone';
import * as fromCalculation from './calculation.reducer';

/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getCalculationsState = createSelector(getMyZoneState, (state: MyZoneState) => state.calculation);
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getAllCalculations = createSelector(getCalculationsState, fromCalculation.getAll);
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getSelectedCalculation = createSelector(getCalculationsState, fromCalculation.getSelected);
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getNotifications = createSelector(getCalculationsState, fromCalculation.getNotifications);
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getFilteredCalculationsTotal = createSelector(getAllCalculations, (calculations) => {
    return calculations.reduce((accumulator: number, calculation: CoveragePremiumInterface) => {
        if (!calculation.product.total_premium_including_discount) {
            return accumulator;
        }

        return (accumulator + calculation.product.total_premium_including_discount.premium_including_premium_tax);
    }, 0);
});
